<template>
    <div
        class="question-row question-row-checkbox"
        :data-lead-service-name="props.content.lead_service_name.value || `extradata-question-${index}`"
    >
        <div
            v-for="(answersGroup, groupKey) in chunkAnswers(props.content.answers, props.content.column_count.value)"
            :key="groupKey"
            class="checkbox-row"
        >
            <div
                v-for="(answer, key) in answersGroup"
                :key="key"
                class="checkbox-column"
            >
                <input
                    :id="`question-${numberOfSameQuestions(props.content.type)}-${groupKey}-checkbox-${key}`"
                    :name="`question-${numberOfSameQuestions(props.content.type)}-${groupKey}-checkbox-${key}`"
                    :value="answer.ELMO_value.value"
                    :data-worktype-id="answer.worktype_id_override?.value"
                    :data-showstopper="answer.showstopper.value"
                    :data-hide-showstopper-close-button="answer.showstopper.hide_showstopper_close_button || false"
                    :data-label="answer.label.value"
                    type="checkbox"
                >

                <label :for="`question-${numberOfSameQuestions(props.content.type)}-${groupKey}-checkbox-${key}`">
                    <div class="checkbox">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 100 100"
                        >
                            <path d="M15.2 31.2l24.3 24.4 42.1-40.4h3.2v27.2l-43 42.9-26.6-25.7z" />
                        </svg>
                    </div>

                    <div class="checkbox-label">
                        {{ answer.label.value }}
                    </div>
                </label>
            </div>
        </div>
    </div>

    <div class="question-row question-row-button">
        <button
            class="question-button-next button"
            type="button"
            value="next"
            data-showstopper="none"
            :data-question-to="props.content.next_question?.value"
            @click="check"
        >
            <zoe-atom-text
                :item="props.content.button_label.value"
            />
        </button>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { addExtraData, getQuestionName, questionProps, storeExtraData } from '../../../../../mixins/quiz/v2.0.0/question';

import ZoeAtomText from '../../../../atoms/text/v1.0.0/zoe-atom-text.vue';
import { checkCompleted } from '../../../../../mixins/quiz/v2.0.0/checks';
import { getNextQuestion } from '../../../../../mixins/quiz/v2.0.0/get-next-question';
import { setInvalid } from '../../../../../js/flows/quiz/v1/core/invalid/invalid-1.0.0';
import { chunkAnswers, numberOfSameQuestions } from '../../../../../mixins/quiz/v2.0.0/helpers';
import stripHtml from '../../../../../mixins/utils/strip-html';

const store = useStore();
const props = defineProps(questionProps);

const name = getQuestionName(props);
const uuid = ref(props.content?._info?.uuid);

onMounted(() => {
    addExtraData(name, {
        name,
        value: '',
        mask: '',
        validator: '',
        uuid: uuid.value,
        question: stripHtml(props.content.text.value),
        sendData: props.content.send_to_lead_service?.value !== false,
    });
});

const check = event => {
    const questionWrapper = event.target.closest('.question');
    const inputContainer = questionWrapper.querySelector('.question-row');
    const buttons = questionWrapper.querySelectorAll('.button');
    const delay = questionWrapper.dataset.delay ? parseInt(questionWrapper.dataset.delay) : 0;

    const combinedAnswers = [];
    const combinedLabels = [];
    const checkboxes = inputContainer.querySelectorAll('input');

    for (const checkbox of checkboxes) {
        if (checkbox.checked) {
            combinedAnswers.push(checkbox.value);
            combinedLabels.push(checkbox.dataset.label);

            if (checkbox.dataset.showstopper !== '' && checkbox.dataset.showstopper !== 'none') {
                if (checkbox.dataset.hideShowstopperCloseButton === 'true') store.commit('dialog/preventClose');
                store.commit('dialog/show', checkbox.dataset.showstopper);
                return;
            }
        }
    }

    if (!combinedAnswers.length) {
        setInvalid(inputContainer);
        return;
    }

    const answerValue = `array:${combinedAnswers.join(',')}`;
    const answerLabel = combinedLabels.join(', ');
    const linkedFormInputIdentifier = '';
    const worktypeId = '';
    const enquiryDashboardRedirectVersion = '';
    const nextQuestion = getNextQuestion(event.target.dataset.questionTo, store.state.quiz.currentQuestion);

    checkCompleted(name, buttons, props.preHook, nextQuestion, props.afterHook, answerValue, linkedFormInputIdentifier, worktypeId, enquiryDashboardRedirectVersion, delay);
    storeExtraData(name, 'value', answerValue);
    storeExtraData(name, 'label', answerLabel);
};
</script>

<style lang="scss">
@use 'zoe-quiz-checkbox';

.question-row-checkbox {
    --column-count-checkbox: v-bind('props.content.column_count.value');
}
</style>
